export const maxContentWidth = '80rem';

export const gridSpacing = '32px';
export const maxHeaderHeight = '104px';
export const headerPlusSpacingSize = `calc(${maxHeaderHeight} + ${gridSpacing})`;
